import {queryOptions} from '@tanstack/react-query';
import {api} from '@/libs/baseApi.client';
import type {Action} from '../type/action';

interface ActionByIdOptionsProps {
  id: number | string;
  type: 'poll' | 'quiz' | 'challenge' | 'platform' | 'social_media';
}

export const actionByIdOptions = ({id, type}: ActionByIdOptionsProps) =>
  queryOptions({
    queryKey: ['action-by-id', id, type],
    queryFn: async (): Promise<Action> => {
      try {
        const response = await api.get<Action>(`/actions/${type}/${id}`);

        return response.data;
      } catch (error) {
        console.error('Failed to fetch action by id:', error);
        return {
          id: 0,
          actionTypeId: 0,
          actionType: {
            id: 0,
            actionTypeName: '',
            coinsCost: 0,
            rewardId: 0,
            reward: {
              id: 0,
              name: '',
              poeAmount: 0,
              coinsAmount: 0,
              poeGoldStatusAmount: 0,
              coinsGoldStatusAmount: 0,
              createdAt: new Date(),
              updatedAt: new Date(),
            },
          },
          headerText: '',
          questionText: '',
          questions: [],
          answers: [],
          imageLink: '',
          startDateTime: new Date(),
          finishDateTime: new Date(),
          isActive: false,
          celebrity: {
            id: 0,
            shortName: '',
            firstName: '',
            lastName: '',
            headerAvatarImg: '',
            isValidated: false,
          },
          type: '',
          title: '',
          description: '',
          createdAt: new Date(),
          updatedAt: new Date(),
          isActiveRaw: false,
        };
      }
    },
    // Добавляем настройки для лучшей работы с SSG
    staleTime: 5 * 60 * 1000, // 5 минут
    retry: 1, // Только одна попытка повтора
  });
